import React from 'react';

import PropTypes from 'prop-types';

import Error401 from '@src/containers/errors/401error';
import Error403 from '@src/containers/errors/403error';
import Error404 from '@src/containers/errors/404error';
import Error500 from '@src/containers/errors/500error';

const ApiError = ({ error }) => {
    if (!error) {
        return null;
    }

    if (error.response && error.response.status) {
        switch (error.response.status) {
        case 401:
            return <Error401 />;
        case 403:
            return <Error403 />;
        case 404:
            return <Error404 />;
        default:
            return <Error500 />;
        }
    }

    // Just uknown error
    return <Error500 />;
};

ApiError.propTypes = {
    error: PropTypes.shape({
        response: PropTypes.shape({
            status: PropTypes.number,
        }),
    }),
};

export default ApiError;
